import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Label, ModalBody, ModalFooter } from "reactstrap";
import { object, string } from "yup";
import ToastHandler from "../../../components/Common/ToastHandler";
import Axios from "../../../lib/Axios";
import useSkillGroupStore from "../../../zStore/skillGroupStore";
import useSkillListStore from "../../../zStore/skillListStore";

const schema = object({
  groupId: string().required("Required"),
  skillId: string().required("Required"),
});

const SkillGroupAssociationForm = ({ data, setEditData, refetch }) => {
  const [toast, setToast] = useState(false);

  const [toastData, setToastData] = useState({
    title: "",
    message: "",
  });

  const { groupSkillSelectCompatiable } = useSkillGroupStore();
  const { skillListSelectCompatiable } = useSkillListStore();

  async function onSubmit(formData) {
    try {
      const dt = data
        ? {
            ...formData,
            groupSkillId: data.groupSkillId,
            isVerified: true,
          }
        : {
            ...formData,
            isVerified: true,
          };

      const result = data
        ? await Axios.post("/cms/cms-edit/skill-group-association", dt)
        : await Axios.post("/cms/cms-set/skill-group-association", dt);

      setToastData({
        message: "Submitted",
        title: "Success",
      });
      setToast(true);
      refetch();
    } catch (error) {
      if (error.status === 500) {
        setToastData({
          message: error.response.data.error.message,
          title: "Error",
        });
        setToast(true);
      } else if (error.status === 400) {
        setToastData({
          message: error.response.data.message,
          title: "Error",
        });
        setToast(true);
      }
    }
  }

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      groupId: data ? data?.groupId : "",
      skillId: data ? data?.skillId : "",
      // companyName: data ? data?.companyName : "",
    },
    validationSchema: schema,
    onSubmit: onSubmit,
  });

  useEffect(() => {
    return () => {
      if (data) {
        setEditData(null);
      }
    };
  }, []);

  return (
    <>
      <form className="tablelist-form" onSubmit={formik.handleSubmit}>
        <ModalBody>
          <div className="mb-3">
            <Label>Group Skill</Label>
            <Select
              defaultValue={
                data && {
                  label: data.SkillGroupName.groupName,
                  value: data.groupId,
                }
              }
              isSearchable={true}
              onChange={(e) => {
                formik.setFieldValue("groupId", e.value);
              }}
              name="color"
              options={groupSkillSelectCompatiable}
            />
            {formik.touched.groupId && formik.errors.groupId && (
              <div className="error">{formik.errors.groupId}</div>
            )}
            <div className="my-2"></div>

            <Label>Skill</Label>
            <Select
              defaultValue={
                data && {
                  label: data.Skill.skillName,
                  value: data.skillId,
                }
              }
              isSearchable={true}
              onChange={(e) => {
                formik.setFieldValue("skillId", e.value);
              }}
              name="color"
              options={skillListSelectCompatiable}
            />
            {formik.touched.skillId && formik.errors.skillId && (
              <div className="error">{formik.errors.skillId}</div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="hstack gap-2 justify-content-end">
            {/* <button
            type="button"
            className="btn btn-light"
            // onClick={() => setmodal_list(false)}
          >
            Close
          </button> */}
            <button
              disabled={formik.isSubmitting}
              type="submit"
              className="btn btn-success"
            >
              {formik.isSubmitting ? "Wait..." : "Submit"}
            </button>
          </div>
        </ModalFooter>
      </form>
      <ToastHandler
        open={toast}
        setOpen={setToast}
        duration={2000}
        message={toastData.message}
        title={toastData.title}
      />
    </>
  );
};

export default SkillGroupAssociationForm;
